import { getPortalComponents } from "../../../components/Portal";

const {
  ContentRendered: FormFooter,
  ContentPlaceholder: FormFooterPlaceholder,
} = getPortalComponents();


export {
  FormFooter,
  FormFooterPlaceholder,
};
